import gameMetadataJson from '@/features/live-engine/data/game-metadata.json';
import { normalizeLang } from '@/lib/i18n/lang-cookie';
import type { StageContentApiData, StageContentApiInnerContent } from '@/types/stage-content-api';
import type { StageInstructionContentMap } from '@/types/instruction-content';
import type { StageId } from '@/types/stage-theme';
import { isStageContentEnvelope, mapStageContentApiToMazeInstructionMap } from '@/utils/map-stage-content-api';

interface GameMetadataStageContentEntry {
  language: string;
  content: StageContentApiInnerContent;
}

interface GameMetadataShape {
  game_index?: number;
  stage_content: GameMetadataStageContentEntry[];
}

const gameMetadata = gameMetadataJson as unknown as GameMetadataShape;

/** Builds instruction-screen content from the bundled `game-metadata.json` (no backend call). */
export function getLocalStageContent(
  uiStageId: StageId,
  lang?: string | null,
): Partial<StageInstructionContentMap> | null {
  const resolvedLang = normalizeLang(lang ?? null).toUpperCase();
  const section =
    gameMetadata.stage_content.find((entry) => entry.language === resolvedLang) ??
    gameMetadata.stage_content[0];

  if (!section) {
    return null;
  }

  const data: StageContentApiData = {
    game_index: gameMetadata.game_index,
    content_section: { language: section.language, content: section.content },
  };

  if (!isStageContentEnvelope(data)) {
    return null;
  }

  return mapStageContentApiToMazeInstructionMap(data, uiStageId);
}
